<template>
    <div class="h5_page">
<!--       :src="`${GlobalConfig.domain.junziqianH5Op}/derong/signInfo/viewDetail_new?${qs.stringify(query)}`"-->
      <iframe
        :src="src"
        class="iframe-sty"
        frameborder
      >
      </iframe>
    </div>
</template>

<script>
    export default {
      name: "h5page",
      mounted() {
        // this.src =
        console.log(location, this.$route, '========')
      },
      computed: {
        src() {
          return this.$route.query.src;
        }
      },
      methods: {

      },
      layout: "h5PageLayout"
    }
</script>

<style scoped lang="less">
  .h5_page {
    margin: auto;
    text-align: center;
    .iframe-sty {
      width: 500px;
      height: 99vh;
    }
  }
</style>



// WEBPACK FOOTER //
// pages/m/h5page.vue